import React from 'react'
import GlobalDailybreakContext from 'global/context/context'
import analytics from 'global/AnalyticsData'
import sessionStorageWrapper from 'util/SessionStorageWrapper'

const injectFacebookScript = () => {
  const script = document.createElement('script')
  script.async = true
  script.defer = true
  script.src = 'https://connect.facebook.net/en_US/sdk.js#xfbml=1&version=v12.0'
  script.setAttribute('crossorigin', 'anonymous')
  script.setAttribute('nonce', 'FYZkWcw1')

  document.getElementsByTagName('body')[0].appendChild(script)
}

const fingerPrintUrl = 'https://dailybreak-scripts.s3.amazonaws.com/fv3.js'

const injectFingerprintJS = async () => {
  const script = document.createElement('script')
  script.async = true
  script.defer = true

  script.innerHTML = `
    (async () => {
      try {
        const FingerprintJS = await import("${fingerPrintUrl}");
        const fp = await FingerprintJS.load();
        const result = await fp.get();
        window.fingerPrintResult = result;
      } catch (error) {
        console.error('Error loading FingerprintJS:', error);
      }
    })();`

  document.body.appendChild(script)
}
export const wrapRootElement = ({ element }) => {
  return <GlobalDailybreakContext>{element}</GlobalDailybreakContext>
}

const setCookie = function (name, value, days) {
  var expires = ''
  if (days) {
    var date = new Date()
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000)
    expires = '; expires=' + date.toUTCString()
  }
  document.cookie =
    name +
    '=' +
    (value || '') +
    expires +
    '; path=/; domain=.dailybreak.com; secure: true; samesite: strict;'
}

export const onPreRouteUpdate = ({ location, prevLocation }) => {
  if (typeof window !== 'undefined') {
    // console.log("event: page_view")
    window.dataLayer.push({
      event: 'page_view',
    })

    analytics.setStep({})
    analytics.setBreak({})
  }
}

let injectedFacebookScript = false
var injectedFingerprintJS = false

export const onRouteUpdate = (args, pluginOptions = {}) => {
  if (!injectedFingerprintJS) {
    injectFingerprintJS()
    injectedFingerprintJS = true
  }

  if (document.querySelector('.fb-comments') !== null) {
    if (!injectedFacebookScript) {
      injectFacebookScript()
      injectedFacebookScript = true
    } else {
      if (window && window.FB) {
        window.FB.XFBML.parse()
      }
    }
  }

  //forcing consent for cookiebot
    if (window.Cookiebot) {
      if (window.Cookiebot.hasResponse === false) {
        window.Cookiebot.submitCustomConsent(true, true, true)
      }
    }


}
